import {DataGridPro} from '@mui/x-data-grid-pro'
import {envBackHost} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {accountColumns} from 'pages/account/dataConfig/declearColumns'
import {accountFilter} from 'pages/account/dataConfig/declearFilters'
import {accountRows} from 'pages/account/dataConfig/declearRows'
import CreateUserModal from 'pages/account/modules/createUserModal'
import UpdateUserModal from 'pages/account/modules/updateUserModal'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {
  getAccountList,
  getAccountTypeList,
  getAllOfficeList,
  getCooperList,
} from 'utils/apiCalling/api'
import {globalRowsPerPageOptions} from 'utils/const/globalConst'
import {resultAlert} from 'utils/CustomAlert/Alert'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'
import AddAccountTypeModal from '../modules/addAccountTypeModal'
import ChangeAccountTypeModal from '../modules/changeAccountTypeModal'

const Account = (props: any) => {
  const updateDataInit = {
    name: '',
    phoneNumber: '',
    email: '',
    accountType: '',
    idActiveStatus: '',
    memo: '',
    officeId: '',
    cooperIdx: '',
    imageUrl: '',
  }

  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const [pageSize, setPageSize] = useState<number>(30)
  const [createUserOpen, setCreateUserOpen] = useState(false)
  const [updateUserOpen, setUpdateUserOpen] = useState(false)
  const createUserModalOpen = () => setCreateUserOpen(true)
  const createUserModalClose = () => setCreateUserOpen(false)
  const updateUserModalOpen = () => setUpdateUserOpen(true)
  const updateUserModalClose = () => setUpdateUserOpen(false)
  const [userDetailData, setUserDetailData] = useState<any>(null)
  const [accountList, setAccountList] = useState<any>(null)
  const [accountTypeList, setAccountTypeList] = useState<any>(null)
  const [officeList, setOfficeList] = useState<any>([])
  const [cooperList, setCooperList] = useState<any>(null)
  const [singleAccountType, setSingleAccountType] = useState<any>({
    accountType: '',
    accountTypeName: '',
  })
  //
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const [filter, setFilter] = useState<any>(accountFilter)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)

  const getOfficeListCall = async () => {
    getAllOfficeList(userInfo, {
      success: (res: any) => {
        setOfficeList(res)
      },
      fail: (error: any) => {
        console.log(error)
      },
    })
  }
  const getAccountListCall = async () => {
    getAccountList(officeInfo, filter, {
      success: (res: any) => {
        setAccountList(res)
      },
      fail: (error: any) => {
        console.log(error)
      },
    })
  }
  const getCooperListCall = () => {
    getCooperList({
      success: (res: any) => {
        setCooperList(res)
      },
      fail: (error: any) => {
        console.log(error)
      },
    })
  }
  const getAccountTypeListCall = async () => {
    getAccountTypeList({
      success: (res: any) => {
        setAccountTypeList(res)
      },
      fail: (error: any) => {
        console.log(error)
      },
    })
  }
  const changeIdActiveStatusHandler = async (selected: any) => {
    axiosWithAuth()
      .put(`${envBackHost}/account`, {
        name: selected?.name,
        phoneNumber: selected?.phoneNumber,
        email: selected?.email,
        accountType: selected?.accountType,
        idActiveStatus: !selected?.idActiveStatus,
        team: '1',
        memo: selected?.memo,
        officeId: selected?.officeId,
        cooperIdx: selected?.cooperIdx,
        imageUrl: selected?.imageUrl,
        id: selected?.id,
        updateId: userInfo?.id,
      })
      .then(async (res) => {
        await resultAlert(res.data)
        if (res.data.resultCode === 0) {
          getAccountListCall()
          return
        }
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }
  const columns: any = accountColumns(changeIdActiveStatusHandler)

  const rows = accountRows(accountList)

  useEffect(() => {
    getAccountListCall()
    getAccountTypeListCall()
    getOfficeListCall()
    getCooperListCall()
  }, [filter.accountType, filter.idActiveStatus, officeInfo])
  //
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.account.description}
        tooltipText={toolTipText.account.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'account'}
        setFilter={setFilter}
        searchCallback={getAccountListCall}
        accountTypeList={accountTypeList}
        total={rows?.length}
        control={['role', 'isActive']}
        actions={['create']}
        onCreateUserModalOpen={createUserModalOpen}
        searchOptions={['userId', 'userName']}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowHeight={60}
          autoHeight={true}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={globalRowsPerPageOptions}
          disableColumnMenu
          pagination
          onCellClick={(params) => {
            setUserDetailData(params.row)
            // const myModal = new bootstrap.Modal(
            //   document.getElementById('userDetailModal') as HTMLElement,
            //   {
            //     keyboard: false,
            //     backdrop: true,
            //   }
            // )
            // myModal.show()
            updateUserModalOpen()
          }}
          loading={accountList?.length < 0}
          onPageChange={() => {
            scrollTop()
          }}
        />
      </MeterariumPageLayout>

      {/*<UserDetailModal*/}
      {/*  data={userDetailData}*/}
      {/*  setUserDetailData={setUserDetailData}*/}
      {/*  officeList={officeList}*/}
      {/*  cooperList={cooperList}*/}
      {/*  getAccountList={getAccountListCall}*/}
      {/*/>*/}
      <AddAccountTypeModal
        accountTypeList={accountTypeList}
        singleAccountType={singleAccountType}
        setSingleAccountType={setSingleAccountType}
      />
      <ChangeAccountTypeModal
        accountTypeList={accountTypeList}
        singleAccountType={singleAccountType}
        setSingleAccountType={setSingleAccountType}
        setAccountTypeList={setAccountTypeList}
      />
      <CreateUserModal
        open={createUserOpen}
        close={() => createUserModalClose()}
        accountTypeList={accountTypeList}
        officeList={officeList}
        cooperList={cooperList}
      />
      <UpdateUserModal
        open={updateUserOpen}
        accountTypeList={accountTypeList}
        close={() => updateUserModalClose()}
        data={userDetailData}
        officeList={officeList}
        cooperList={cooperList}
        getAccountList={getAccountListCall}
      />
    </>
  )
}
export default Account
